<template>
	<div class="content-wrapper">
		<!-- Content -->

		<div class="container flex-grow-1 container-p-y">
			<div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4">
				<div class="d-flex flex-column justify-content-center">
					<h4 class="mb-1">Liste des attestations de vos stagiaires</h4>
					<p class="mb-0">Vous pouvez retrouver les attestations de formation de vos stagiaires</p>
				</div>
				<div class="d-flex align-content-center flex-wrap gap-4">
					<button class="btn btn-primary waves-effect waves-light" type="button" disabled="" v-if="isDownloading">
						<span class="spinner-border me-1" role="status" aria-hidden="true"></span>
						Chargement...
					</button>
					<button type="submit" class="btn btn-primary" @click="downloadAllCertificates()" v-if="!isDownloading">Télécharger toutes les attestations</button>
				</div>
			</div>

			<div class="spinner-border spinner-border-lg text-primary load-center" role="status" v-if="isLoading">
				<span class="visually-hidden">Chargement...</span>
			</div>

			<div class="col-lg-12" v-if="!isLoading">
				<div class="card h-100">
					<div class="table-responsive">
						<table class="table table-borderless">
							<thead>
								<tr class="border-bottom">
									<th class="bg-transparent fs-xsmall">Numéro</th>
									<th class="bg-transparent fs-xsmall">Formation</th>
									<th class="bg-transparent fs-xsmall">Type</th>
									<th class="bg-transparent fs-xsmall">Version</th>
									<th class="bg-transparent fs-xsmall">Émise le</th>
									<th class="bg-transparent fs-xsmall">Actions</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(certificate, index) in certificates" :key="index">
									<td>
										<div class="d-flex justify-content-start align-items-center">
											<div>
												<h6 class="mb-0 text-truncate">
													Attestation {{ certificate.user.firstName }} {{ certificate.user.lastName }}
												</h6>
											</div>
										</div>
									</td>
									<td>
										<span class="badge bg-label-info rounded-pill">{{ certificate.formationName }}</span>
									</td>
									<td>
										<span 
											v-if="certificate.type === 'renewal'"
										>
											Périodique
										</span>
										<span v-else>
											Initiale
										</span>
									</td>
									<td>
										{{ certificate.versionName }}
									</td>
									<td>
										{{ formatDate(certificate.createdAt) }}
									</td>
									<td>
										<a href="javascript:void(0);" class="btn btn-sm btn-icon btn-text-secondary rounded-pill me-1 waves-effect waves-light" @click="downloadCertificate(certificate._id)" >
											<i class="ri-download-2-line ri-22px"></i>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<!-- / Content -->

		<div class="content-backdrop fade"></div>
	</div>
</template>

<script>
import HTTP from "@/axios";
import moment from "moment";
import "moment/locale/fr";

moment.locale("fr");

export default {
	name: "ConventionPages",

	data() {
		return {
			isLoading: true,
			isDownloading: false,
			certificates: [],
		};
	},

	methods: {
		async fetchConventions() {
			try {
				const response = await HTTP('/certificates');
				this.certificates = response.data.certificates;
				this.isLoading = false;
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || "Une erreur est survenue, merci de contacter contact@pika-aero.com";

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		async downloadCertificate(trainingId) {
			try {
				// Appel API pour récupérer le PDF en base64
				const response = await HTTP.post(`/certificates/download`, { trainingId });

				if (response.data?.base64) {
					// Convertir la base64 en un Blob et créer un lien de téléchargement
					const byteCharacters = atob(response.data.base64);
					const byteNumbers = new Array(byteCharacters.length);
					for (let i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					const byteArray = new Uint8Array(byteNumbers);
					const blob = new Blob([byteArray], { type: 'application/pdf' });

					// Créer un lien pour le téléchargement
					const link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = `attestation_${trainingId}.pdf`;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				} else {
					throw new Error("Fichier non disponible.");
				}
			} catch (error) {
				// Gestion des erreurs
				const errorMessage = error?.response?.data?.message || 
					"Une erreur est survenue, merci de contacter contact@pika-aero.com";
				alert(errorMessage);
				console.error("Erreur API:", error);
			}
		},

		async downloadAllCertificates() {
			try {
				this.isDownloading = true;

				// Appel API pour récupérer le PDF en base64
				const response = await HTTP.post(`/certificates/download-all`);

				if (response.data?.base64) {
					// Convertir la base64 en un Blob et créer un lien de téléchargement
					const byteCharacters = atob(response.data.base64);
					const byteNumbers = new Array(byteCharacters.length);
					for (let i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					const byteArray = new Uint8Array(byteNumbers);
					const blob = new Blob([byteArray], { type: 'application/zip' });

					// Créer un lien pour le téléchargement
					const link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = `Attestations Pika Aero.zip`;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);

					this.isDownloading = false;
				} else {
					throw new Error("Fichier non disponible.");
				}
			} catch (error) {
				// Gestion des erreurs
				const errorMessage = error?.response?.data?.message || 
					"Une erreur est survenue, merci de contacter contact@pika-aero.com";
				alert(errorMessage);
				console.error("Erreur API:", error);
			}
		},

		formatDate(date) {
			return moment(date).format("DD/MM/YYYY"); // Affiche "il y a 3 semaines"
		},

		formatRelativeDate(date) {
			return moment(date).fromNow(); // Affiche "il y a 3 semaines"
		},
	},

	async mounted() {
		this.fetchConventions();
	}
};
</script>

<style scoped>
/* Ajoutez des styles spécifiques à la page Dashboard */
.dashboard {
	padding: 1rem;
}

.card-title {
	font-size: 1.2rem;
}

.card-text {
	margin: 0;
}

.load-center {
	display: block;
	margin: 0 auto;
}
</style>
